module.exports = __webpack_public_path__ + "img/down-arrow.a4690277.svg";